module.exports = __webpack_public_path__ + "static/media/paper_airplane.8982e1ee.svg";